// extracted by mini-css-extract-plugin
module.exports = {"root":"design-quote_root__x7ani","text":"design-quote_text__qfyO8"};